import axios from 'axios';


export default {
    getDetailInfo(idQuote){
        return axios.get('cliente/detalle/cotizacion?token='+idQuote)
    },
    approveQuotationClient(data){
        return axios.post('cliente/aprobar',data)
    },
    declineQuotationClient(data){
        return axios.post('cliente/rechazar',data)
    },
    updateTotalClient(data){
        return axios.post('cliente/guardar/total',data)
    }
}